import Vue from 'vue';
import App from './App.vue';
import Vuex from 'vuex';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import preventReClick from './directives/preventReClick';
import VueI18n from 'vue-i18n'
import en from './locales/en.json'
import zh from './locales/zh.json'

Vue.use(ElementUI);
Vue.use(Vuex)
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'zh',
  messages: {
    en,
    zh
  }
})
Vue.directive('prevent-reclick', preventReClick);
const store = new Vuex.Store({
  state: {
    token: '' // 或其他初始状态
  },
  getters: {
    token: state => state.token
  }
});
new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app');